import * as React from 'react';
import axios from 'axios';
import {
  Alert, Heading, Row, Col, Button, FormattedTextField, Select,
} from '@elevationscu/ui-component-lib';
import styles from './additional-questions.module.scss';
import InputRequest from './input-request';
import DataDisclaimer from './data-disclaimer';
import ProgressBar from './ProgressBar';
import prospectPut from './helper-functions';

export default function AdditionalQuestions({
  pageNumber, userInfo, previousPage, setUserInfo, maxPages,
}) {
  const [homeToSell, setHomeToSell] = React.useState(false);
  const [submitMessage, setSubmitMessage] = React.useState(null);
  const [messageTitle, setMessageTitle] = React.useState(null);
  const [messageType, setMessageType] = React.useState(null);
  const [sellableHomeAnswer, setSellableHomeAnswer] = React.useState();
  const [previousHomeAnswer, setPreviousHomeAnswer] = React.useState(null);
  const [totalAnnualIncome, setTotalAnnualIncome] = React.useState();
  const [typeOfIncome, setTypeOfIncome] = React.useState();
  const [vetStatus, setVetStatus] = React.useState();
  const [validatedFields, setValidatedFields] = React.useState(false);

  React.useEffect(() => {
    if (sellableHomeAnswer || sellableHomeAnswer === false || previousHomeAnswer === false) {
      setValidatedFields(true);
    } else {
      setValidatedFields(false);
    }
    // sets the state if it exists, in the event a prospect has returned to a previous page
    if ('type_of_income' in userInfo.application_data) setTypeOfIncome(userInfo.application_data.type_of_income);
    if ('total_annual_income' in userInfo.application_data) setTotalAnnualIncome(userInfo.application_data.total_annual_income);
    if ('previous_home' in userInfo.application_data) setPreviousHomeAnswer(userInfo.application_data.previous_home);
    if ('sellable_home' in userInfo.application_data) setSellableHomeAnswer(userInfo.application_data.sellable_home);
    if ('vet_status' in userInfo.application_data) setVetStatus(userInfo.application_data.vet_status);
    if (userInfo.application_data.previous_home) setHomeToSell(true);
  }, [sellableHomeAnswer, previousHomeAnswer, vetStatus, userInfo.application_data]);

  function previous() {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      previous_home: previousHomeAnswer,
      sellable_home: sellableHomeAnswer,
      vet_status: vetStatus,
      type_of_income: typeOfIncome,
      total_annual_income: totalAnnualIncome,
    });
    setUserInfo(userInfo);
    previousPage(userInfo);
  }

  function hasPreviouslyOwnedHome(answer) {
    setHomeToSell(answer);
    setPreviousHomeAnswer(answer);
    // will default userSellableHome to false if a user clicks no for previouslyOwnedHome
    function setPreviousHome() {
      if (!answer) {
        userInfo.application_data = Object.assign(userInfo.application_data, {
          previous_home: answer,
          sellable_home: answer,
        });
      }
      userInfo.application_data = Object.assign(userInfo.application_data, {
        previous_home: answer,
        total_annual_income: '',
        type_of_income: 'Salary',
      });
    }
    setPreviousHome();
  }

  function hasHomeToSell(answer) {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      sellable_home: answer,
    });
    setSellableHomeAnswer(answer);
  }

  function isVeteran(answer) {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      vet_status: answer,
    });
    setVetStatus(answer);
  }

  function changeApplicationDataField(field, value) {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      [field]: value,
    });
  }

  async function submitApp() {
    try {
      await prospectPut(userInfo);
      const finalizeResponse = await axios.put(`${process.env.REACT_APP_API_URL}/prospect/finalize`, {
        application_id: userInfo.application_id,
        email: userInfo.email,
        phone: userInfo.phone,
      });

      if (finalizeResponse.status === 200) {
        window.location.href = `${process.env.REACT_APP_ENV_PUBLIC_WEB_ADDRESS}/mortgage-questionnaire-submission`;
      } else {
        setSubmitMessage("Something happened.  We'll be working on fixing this as soon as possible, so try again soon.");
        setMessageTitle('Uh oh!');
        setMessageType('error');
      }
    } catch (error) {
      setSubmitMessage("Something happened.  We'll be working on fixing this as soon as possible, so try again soon.");
      setMessageTitle('Uh oh!');
      setMessageType('error');
      console.error(error);
    }
  }
  return (
    <div className={styles.mainContainer}>
      <div className={styles.coreData}>
        <div className={styles.coreHeader}>
          <Heading element="h1" size={2} className={styles.heading}>
            Just a few last questions...
          </Heading>
          <InputRequest />
        </div>
        <div className={styles.prospectInput}>
          <ProgressBar pageNumber={pageNumber} maxPages={maxPages} />
          <fieldset className={styles.fieldset}>
            <legend>
              <Heading element="h1" size={3} className={styles.subHeading}>
                Have you owned a home in the last three years? (required)
              </Heading>
            </legend>
            <Button
              variant="secondary"
              onClick={() => hasPreviouslyOwnedHome(true)}
              className={previousHomeAnswer === true ? styles.chosenButton : styles.answerButton}
              id="btn_previousHome_yes"
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              onClick={() => hasPreviouslyOwnedHome(false)}
              id="btn_previousHome_no"
              className={previousHomeAnswer === false ? styles.chosenButton : styles.answerButton}
            >
              No
            </Button>
          </fieldset>
          {homeToSell
                        && (
                        <div>
                          <fieldset className={styles.fieldset}>
                            <legend>
                              <Heading element="h2" size={3} className={styles.subHeading}>
                                Do you have a home to sell? (required)
                              </Heading>
                            </legend>
                            <Button
                              variant="secondary"
                              onClick={() => hasHomeToSell(true)}
                              className={sellableHomeAnswer === true ? styles.chosenButton : styles.answerButton}
                              id="btn_sellableHome_yes"
                            >
                              Yes
                            </Button>
                            <Button
                              variant="secondary"
                              onClick={() => hasHomeToSell(false)}
                              className={sellableHomeAnswer === false ? styles.chosenButton : styles.answerButton}
                              id="btn_sellableHome_no"
                            >
                              No
                            </Button>
                          </fieldset>
                        </div>
                        )}
          {!previousHomeAnswer && previousHomeAnswer !== null
                        && (
                        <div>
                          <fieldset className={styles.fieldset}>
                            <legend>
                              <Heading element="h2" size={3} className={styles.subHeading}>
                                You may qualify for a first-time homebuyer program.  Please provide income information if you'd like us to explore your options. (optional)
                              </Heading>
                            </legend>
                            <Row>
                              <Col xs={6} lg={4}>
                                <FormattedTextField
                                  label="Total annual income"
                                  format="dollars"
                                  id="total-annual-income"
                                  key={totalAnnualIncome}
                                  value={totalAnnualIncome}
                                  onBlur={(e) => {
                                    changeApplicationDataField('total_annual_income', e.target.value);
                                    setTotalAnnualIncome(e.target.value);
                                  }}
                                />
                              </Col>
                              <Col xs={6} lg={4}>
                                <Select
                                  label="Type of income"
                                  id="type-of-income"
                                  value={typeOfIncome}
                                  onChange={(e) => {
                                    changeApplicationDataField('type_of_income', e.target.value);
                                    setTypeOfIncome(e.target.value);
                                  }}
                                >
                                  <option value="Salary">Salary</option>
                                  <option value="Hourly">Hourly</option>
                                  <option value="Commissions">Commissions</option>
                                  <option value="Self-Employed">Self-Employed</option>
                                </Select>
                              </Col>
                            </Row>
                          </fieldset>
                        </div>
                        )}
          <Row>
            <Col lg={12}>
              <fieldset className={styles.fieldset}>
                <legend>
                  <Heading element="h2" size={3} className={styles.subHeading}>
                    Have you served in the military? (optional)
                  </Heading>
                </legend>
                <Button
                  variant="secondary"
                  onClick={() => isVeteran(true)}
                  className={vetStatus === true ? styles.chosenButton : styles.answerButton}
                  id="btn_vet_yes"
                >
                  Yes
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => isVeteran(false)}
                  className={vetStatus === false ? styles.chosenButton : styles.answerButton}
                  id="btn_vet_no"
                >
                  No
                </Button>
              </fieldset>

            </Col>
            <Col lg={4} className={styles.vetColumn}>
              {vetStatus
                && (
                <div className={styles.vetBanner} id="veteranBanner">
                  Thank you for your service. You may qualify for special loan programs!
                </div>
                )}
            </Col>
          </Row>
          <Row className={styles.rowSpacing}>
            <Col lg={8}>
              <DataDisclaimer />
            </Col>
            <Col className={styles.colSpacing}>
              <button onClick={previous} className={styles.previousButton} id="btn_previous" type="button">
                Previous
              </button>
              <Button onClick={submitApp} disabled={!validatedFields} className={styles.submitButton} id="btn_submit">
                Submit
              </Button>
            </Col>
          </Row>
          {submitMessage
                        && (
                        <div>
                          <Alert title={messageTitle} variant={messageType} className={styles.alertBanner}>
                            {submitMessage}
                          </Alert>
                        </div>
                        )}
        </div>
      </div>
    </div>
  );
}
